var ImageLayer = require("./ImageLayer"),
    OLVectorLayerStyle = require('OLVectorLayerStyle'),
    ol = require("openlayers"),
    $ = require("jquery");

var OmsVectorFeatureLayer = ImageLayer.extend({

    /**
     *
     * @param options
     */
    initialize: function(options){
        var that = this;
        OmsVectorFeatureLayer.__super__.initialize.call(that, options);
    },

    _setup: function(options){
        var that = this;

        options || (options = {});

        if('projectLayers' in options){
            that._prjLayers = options.projectLayers;
        }

        if(that._prjLayers && that._prjLayers.getLength() > 0){

            that.project = that._prjLayers.at(0).options.project;
            // страшный костыль, т.к. нет нормального пути до изображений
            that.markerImgUrl = that.project.options.apiUrl.replace(/\/api\/[0-9\.]+\//g, '/img/');

            OmsVectorFeatureLayer.__super__._setup.call(that, options);
        }

        return that;
    },

    updateLayer: function() {
        var that     = this;
        that.styleCache = {};
        OmsVectorFeatureLayer.__super__.updateLayer.call(that, that.options);
    },

    setLayerStyle: function(){
        var that = this,
            layer = that._olLayer,
            mapStyles = {},
            i,
            prjLayersCount,
            code,
            regExpTooltip = /-tooltip$/;

        // Чистим сохраненные стили
        // todo т.к. кеш м.б. достаточно громодким, необходимо организовать его очистку по уму
        that.styleCache = {};
        that.hiddenStyle = [];
        that.layerSort = {};
        prjLayersCount = that._prjLayers.getLength();

        for (i = 0; i < prjLayersCount; i ++) {
            code = that._prjLayers.getArray()[i].get('code');
            // не используется sort слоя, потому что он не глобальный
            that.layerSort[code] = prjLayersCount - i;
            if (!that._prjLayers.getArray()[i].get('mapnik_style')) {
                continue;
            }
            mapStyles[code] = new OLVectorLayerStyle(that._prjLayers.getArray()[i].get('mapnik_style'), (prjLayersCount - i), that.markerImgUrl);
            // коды для тултипов
            mapStyles[code].styles.forEach(function (style) {
                if (!regExpTooltip.test(style['name'])) {
                    return;
                }
                style.rules.forEach(function (rule) {
                    if (!rule.symbolizers.TEXT || !rule.symbolizers.TEXT.cdata) {
                        return;
                    }
                    that._prjLayers.getArray()[i].set('popupCode', rule.symbolizers.TEXT.cdata);
                });
            });
        }

        layer.setStyle(function pointStyleFunction(feature, resolution) {
            if (~that.activeLayersCodes.indexOf(feature.get('layer')) == 0 || !mapStyles[feature.get('layer')]) {
                return that.hiddenStyle;
            }
            var featureHighlighted = !!feature.get('highlighted');
            var cacheKey = '' + resolution + ':' + feature.get('layer') + ':' + feature.get('orbis_id') + ':' + (featureHighlighted ? '1' : '0');
            if (cacheKey in that.styleCache) {
                return that.styleCache[cacheKey];
            }
            var curZoom = that._view.getMap().getView().getZoom();
            var styles = mapStyles[feature.get('layer')].getStyle(feature, curZoom, that.layerSort);
            var highlightStyle,
                highlightStyleFill,
                imageSize,
                canvas,
                shadowOffset,
                canvasContext,
                rgbaFill,
                baseZIndex;
            // подстветка hover
            if (featureHighlighted) {
                highlightStyle = styles.filter(function (style) {
                    return !!style.getImage();
                });
                highlightStyleFill = styles.filter(function (style) {
                    return !!style.getFill();
                });
                if (highlightStyle && highlightStyle.length) {
                    imageSize = highlightStyle[0].getImage().getImageSize();
                    canvas = $("<canvas></canvas>");
                    shadowOffset = 2;
                    canvas
                        .attr({
                            width: imageSize[0] + shadowOffset * 2,
                            height: imageSize[1] + shadowOffset * 2
                        })
                        .css({
                            width: imageSize[0] + shadowOffset * 2,
                            height: imageSize[1] + shadowOffset * 2
                        });
                    canvasContext = canvas[0].getContext("2d");

                    canvasContext.shadowColor = "rgba( 0, 0, 0, 0.3 )";
                    canvasContext.shadowOffsetX = shadowOffset;
                    canvasContext.shadowOffsetY = shadowOffset;
                    canvasContext.shadowBlur = shadowOffset;
                    canvasContext.drawImage(highlightStyle[0].getImage().getImage(), shadowOffset, shadowOffset);

                    try {
                        baseZIndex = OLVectorLayerStyle.baseZIndexMultiplier * (
                            that.layerSort && that.layerSort[feature.get('layer')]
                                ? that.layerSort[feature.get('layer')]
                                : 0
                            );
                        that._setImageGamma(canvas[0], canvasContext, 1.06);
                        styles.push(new ol.style.Style({
                            image: new ol.style.Icon({
                                src: canvas[0].toDataURL(),
                                scale: highlightStyle[0].getImage().getScale(),
                                opacity: 1,
                                rotation: highlightStyle[0].getImage().getRotation()
                            }),
                            // здесь, как и в OLVectorLayerStyle, нужно учитывать грандиозность размеров ZIndex
                            // из-за использование Y координат для построения сортировок отображения объектов
                            zIndex: 1000 * OLVectorLayerStyle.baseZIndexMultiplier + baseZIndex
                        }));
                    } catch (e) {
                        highlightStyle[0].getImage().setOpacity(highlightStyle[0].getImage().getOpacity() * 0.6);
                    }
                    canvas.detach();
                }
                if (highlightStyleFill && highlightStyleFill.length) {
                    rgbaFill = OLVectorLayerStyle.getRGBish(highlightStyleFill[0].getFill().getColor(), true);
                    rgbaFill = [rgbaFill[0] * 1.06 * 1.06, rgbaFill[1] * 1.06 * 1.06, rgbaFill[2] * 1.06 * 1.06, rgbaFill[3]];
                    rgbaFill[0] = rgbaFill[0] > 255 ? 255 : rgbaFill[0];
                    rgbaFill[1] = rgbaFill[1] > 255 ? 255 : rgbaFill[1];
                    rgbaFill[2] = rgbaFill[2] > 255 ? 255 : rgbaFill[2];
                    highlightStyleFill[0].getFill().setColor('rgba('+Math.trunc(rgbaFill[0])+', '+Math.trunc(rgbaFill[1])+', '+Math.trunc(rgbaFill[2])+', '+rgbaFill[3]+')');
                }
                styles.forEach(function (style) {
                    if (style.getText()) {
                        // текст подсвеченного объекта должен отрисоваться раньше остальных текстов, но не раньше объектов
                        style.setZIndex(style.getZIndex() - 100 * OLVectorLayerStyle.baseZIndexMultiplier);
                    }
                });
            }

            that.styleCache[cacheKey] = styles;

            return styles;
        });
    },

    _setImageGamma: function(canvas, context, gamma) {
        var pix = context.getImageData(0, 0, canvas.width, canvas.height);
        var x, y, i, r, g, b, a, ret;
        //Loop through the pixels
        for (x = 0; x < canvas.width; x++) {
            for (y = 0; y < canvas.height; y++) {
                i = (y * canvas.width + x) * 4;
                r = pix.data[i];
                g = pix.data[i + 1];
                b = pix.data[i + 2];
                a = pix.data[i + 3];
                ret = [r * gamma * gamma, g * gamma * gamma, b * gamma * gamma, a];
                pix.data[i] = ret[0];
                pix.data[i + 1] = ret[1];
                pix.data[i + 2] = ret[2];
                pix.data[i + 3] = ret[3];
            }
        }

        //Put the image back to the canvas
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.putImageData(pix, 0, 0);
    }
});

module.exports = OmsVectorFeatureLayer;



//////////////////
// WEBPACK FOOTER
// ./src/View/OmsVectorFeatureLayer.js
// module id = 46
// module chunks = 0